(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/ticker-text.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/ticker-text.js');

'use strict';

const {
  mapZoomLevelAtom
} = svs.lyckoplatsen.shared_map.atoms;
const {
  shouldShowPinAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  useAtomValue
} = jotai;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const TickerText = () => {
  const zoomLevel = useAtomValue(mapZoomLevelAtom);
  const shouldShowPin = useAtomValue(shouldShowPinAtom);
  return React.createElement("div", {
    className: "lp-play-ticker-text ".concat(zoomLevel >= CONSTANTS.PLACE_PIN_ZOOM_LEVEL && !shouldShowPin ? 'ticker-show' : 'ticker-hide')
  }, "Klicka p\xE5 kartan f\xF6r att v\xE4lja plats.");
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  TickerText
});

 })(window);